<div class="modal-body text-center">
  <img class="fa-spin" src="/retired-arbitrum/assets/images/gradient-loading.png" />
  <div class="mt-3">in the progress of completing</div>
  <div class="d-flex gap-1 text-gray mt-2">
    <div class="time">
      <span class="text-info">{{ h | async }}</span> h
    </div>
    <div class="time">
      <span class="text-info">{{ m | async }}</span> m
    </div>
    <div class="time">
      <span class="text-info">{{ s | async }}</span> s
    </div>
  </div>
</div>
